import { UserAccountActions } from '@/app/platform/platform-data/actions/types';
import { ErrorInformation } from '@shared/models/error/error-information';
import { AsyncResult } from '@common/result/asyncResult';
import { USER_ACCOUNT_SERVICE, UserAccountService } from '@/app/platform/platform-data/services/types';
import { Inject, Injectable } from '@angular/core';
import { USER_ACCOUNT_QUERIES, UserAccountQueries } from '@/app/platform/platform-data/queries/types';
import { ok } from '@common/result/Result';
import { UserAccountEntityStore } from '@/app/platform/platform-data/store/user-account.entity.store';
import { UserAccountEntity } from '@/app/platform/platform-data/models/user-account.entity';

@Injectable({
  providedIn: 'root'
})
export class UserAccountStoreActions implements UserAccountActions {
  constructor(
    private readonly userAccountStore: UserAccountEntityStore,
    @Inject(USER_ACCOUNT_SERVICE)
    private readonly userAccountService: UserAccountService,
    @Inject(USER_ACCOUNT_QUERIES)
    private readonly userAccountQueries: UserAccountQueries
  ) {}

  async loadAll(): AsyncResult<UserAccountEntity[]> {
    if (this.userAccountQueries.getHasCache()) {
      const accounts = this.userAccountQueries.getAll();
      return ok(accounts);
    }

    return this.reloadAll();
  }

  async reloadAll(): AsyncResult<UserAccountEntity[]> {
    const result = await this.userAccountService.getAll();
    result.ifSuccess(accounts => {
      this.userAccountStore.set(accounts);
    });

    return result;
  }
}
